<template>
  <v-container fluid>
    <v-card class="ma-5" elevation="8">
      <v-card-title>
        Processes
        <v-spacer/>

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon v-bind="attrs" v-on="on" @click="initRefreshData" :loading="isRefreshingData">
              <v-icon>mdi-reload</v-icon>
            </v-btn>
          </template>
          <span>Reload</span>
        </v-tooltip>
      </v-card-title>

      <v-card-text> <!-- https://codepen.io/lzhoucs/pen/aadaJx -->
        <v-data-table :items="processes" :headers="headers" :search="search" height="calc(100vh - 290px)" fixed-header hide-default-footer disable-pagination :sort-by.sync="sortBy" :sort-desc.sync="sortDesc">
          <!-- Empty table -->
          <template v-slot:no-data>
            <v-alert class="ma-3" color="primary" dark icon="mdi-alert-circle">There are no processes</v-alert>
          </template>

          <!-- Search -->
          <template v-slot:top>
            <v-row>
              <v-col sm="3">
                <v-text-field v-model="search" label="Search" class="mx-4" prepend-icon="mdi-magnify" clearable></v-text-field>
              </v-col>
            </v-row>
          </template>

          <!-- Date row -->
          <template v-slot:[`item.FECHA`]="{ item }">
            <span>{{ item.FECHA | formatDate }}</span>
          </template>

          <!-- Actions row -->
          <template v-slot:[`item.CONTROLS`]="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon v-bind="attrs" v-on="on" @click="initDeleteProcess(item)">
                  <v-icon color="red">mdi-delete</v-icon>
                </v-btn>
              </template>
              <span>Delete</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'ProcessList',

  data: () => ({
    headers: [
      { text: 'Region', value: 'REGION.REGION' },
      { text: 'Fecha', value: 'FECHA', width: 150 },
      { text: 'Is processing?', value: 'IS_PROCESSING', width: 150 },
      { text: 'Error', value: 'ERROR_PROCESSING', width: 80 },
      { text: 'PRE_FOREST_1', value: 'PRE_FOREST_1.NOMBRE', sortable: false },
      { text: 'PRE_NON_FOREST_1', value: 'PRE_NON_FOREST_1.NOMBRE', sortable: false },
      { text: 'PRE_DEFOR_1_2', value: 'PRE_DEFOR_1_2.NOMBRE', sortable: false },
      { text: 'PRE_FOREST_2', value: 'PRE_FOREST_2.NOMBRE', sortable: false },
      { text: 'PRE_NON_FOREST_2', value: 'PRE_NON_FOREST_2.NOMBRE', sortable: false },
      { text: 'PRE_DEFOR_2_3', value: 'PRE_DEFOR_2_3.NOMBRE', sortable: false },
      { text: 'PRE_FOREST_3', value: 'PRE_FOREST_3.NOMBRE', sortable: false },
      { text: 'PRE_NON_FOREST_3', value: 'PRE_NON_FOREST_3.NOMBRE', sortable: false },
      { text: 'PRE_DEFOR_1_3', value: 'PRE_DEFOR_1_3.NOMBRE', sortable: false },
      {
        text: 'Actions',
        value: 'CONTROLS',
        sortable: false,
        width: 70,
        align: 'center fixed',
        class: 'fixed'
      }
    ],
    sortBy: 'FECHA',
    sortDesc: true,
    search: null,

    isRefreshingData: false
  }),
  computed: {
    ...mapGetters('proceso', [
      'processes'
    ])
  },
  methods: {
    ...mapActions('proceso', [
      'getProcesses',
      'deleteProcess'
    ]),
    initRefreshData () {
      this.isRefreshingData = true

      this.getProcesses().catch(() => {
        this.$toastr.e('Error updating data')
      }).finally(() => {
        this.isRefreshingData = false
      })
    },
    async initDeleteProcess (process) {
      this.$root.$confirmDialog.open('Delete process', 'Are you sure you want to delete the process? All files will be deleted').then(async result => {
        if (result) {
          try {
            await this.deleteProcess(process)

            this.$toastr.s('Process deleted correctly')
          } catch (err) {
            this.$toastr.e('Error deleting process')
          }
        }
      })
    }
  },
  mounted () {
  }
}
</script>

<style scoped>
</style>

<style>
  /* CSS for fixed ACTIONS column (necessary to be non-scoped). If needed in another view, put this CSS on App.vue */
  table > tbody > tr > td.fixed:nth-last-child(1),
  table > thead > tr > th.fixed:nth-last-child(1) {
    position: sticky !important;
    position: -webkit-sticky !important;
    right: 0;
    z-index: 998;
    background: white;
    -webkit-box-shadow: -1px 0px 3px -1px rgba(0, 0, 0, 0.19);
    -moz-box-shadow: -1px 0px 3px -1px rgba(0, 0, 0, 0.19);
    box-shadow: -1px 0px 3px -1px rgba(0, 0, 0, 0.19);
  }

  table > thead > tr > th.fixed:nth-last-child(1) {
    z-index: 2;
  }
</style>
